import { render, staticRenderFns } from "./MenuOptionsPage.vue?vue&type=template&id=03bf67c2"
import script from "./MenuOptionsPage.vue?vue&type=script&lang=js"
export * from "./MenuOptionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports